const isResumeType = (document) =>
    document?.attributes?.document_type?.data?.attributes?.title == 'Resume';

// Picks the lowest-id Resume document, matching the CMS, so a contact with
// two Resume documents is judged on the same one the approval guard checks.
export const findResumeDocument = (documents) =>
    (documents || [])
        .filter(isResumeType)
        .reduce(
            (lowest, document) =>
                !lowest || Number(document.id) < Number(lowest.id)
                    ? document
                    : lowest,
            undefined,
        );

// A resume is usable when a reviewer has something to read: written content
// or a link to an uploaded file. Mirrors the CMS approval guard.
export const isUsableResume = (content, link) =>
    Boolean(content?.trim() || link?.trim());

export const isUsableResumeDocument = (document) =>
    isUsableResume(document?.attributes?.content, document?.attributes?.link);
